import * as api from "api/endpoints/analytics";
import { createSlice, createSliceSelector } from "../../factory";

const name = "overviewPortfolioPage";

const initialState = {
  offeredCustomerData: [],
  offeredCustomerUrl: null,
  offeredCustomerCount: 0,
  offeredCustomerLoading: false,

  acceptedCustomerData: [],
  acceptedCustomerUrl: null,
  acceptedCustomerCount: 0,
  acceptedCustomerLoading: false,

  activeCustomerData: [],
  activeCustomerUrl: null,
  activeCustomerCount: 0,
  activeCustomerLoading: false
};

const slice = createSlice(name, initialState);

export default slice.reducer;

/* Selectors */
const createSelector = createSliceSelector(name);

export const selectOfferedCustomer = createSelector((state) => {
  return {
    data: state.offeredCustomerData,
    url: state.offeredCustomerUrl,
    count: state.offeredCustomerCount,
    loading: state.offeredCustomerLoading
  };
});

export const selectAcceptedCustomer = createSelector((state) => {
  return {
    data: state.acceptedCustomerData,
    url: state.acceptedCustomerUrl,
    count: state.acceptedCustomerCount,
    loading: state.acceptedCustomerLoading
  };
});

export const selectActiveCustomer = createSelector((state) => {
  return {
    data: state.activeCustomerData,
    url: state.activeCustomerUrl,
    count: state.activeCustomerCount,
    loading: state.activeCustomerLoading
  };
});

/* Actions */
const { update } = slice.actions;

export function loadPortfolioData(start, end, epId) {
  return async function (dispatch) {
    dispatch(loadOfferedCustomerData(start, end, epId));
    dispatch(loadAcceptedustomerData(start, end, epId));
    dispatch(loadActiveCustomerData(start, end, epId));
  };
}

export function loadOfferedCustomerData(start, end, epId) {
  const config = { params: { start, end, type: "Offered Customers", epId } };

  return async function (dispatch) {
    dispatch(update({ offeredCustomerLoading: true }));

    const overviewData = await api.getOverview(config);
    const reportsData = await api.getOverviewReports(config);

    const payload = {
      offeredCustomerData: overviewData.details,
      offeredCustomerUrl: reportsData.epFileURL,
      offeredCustomerCount: overviewData.totalCount,
      offeredCustomerLoading: false
    };

    dispatch(update(payload));
  };
}

export function loadAcceptedustomerData(start, end, epId) {
  const config = { params: { start, end, type: "Accepted Customers", epId } };

  return async function (dispatch) {
    dispatch(update({ acceptedCustomerLoading: true }));

    const overviewData = await api.getOverview(config);
    const reportsData = await api.getOverviewReports(config);

    const payload = {
      acceptedCustomerData: overviewData.details,
      acceptedCustomerUrl: reportsData.epFileURL,
      acceptedCustomerCount: overviewData.totalCount,
      acceptedCustomerLoading: false
    };

    dispatch(update(payload));
  };
}

export function loadActiveCustomerData(start, end, epId) {
  const config = { params: { start, end, type: "Active Customers", epId } };

  return async function (dispatch) {
    dispatch(update({ activeCustomerLoading: true }));

    const overviewData = await api.getOverview(config);
    const reportsData = await api.getOverviewReports(config);

    const payload = {
      activeCustomerData: overviewData.details,
      activeCustomerUrl: reportsData.epFileURL,
      activeCustomerCount: overviewData.totalCount,
      activeCustomerLoading: false
    };

    dispatch(update(payload));
  };
}
